import { SxProps, Theme } from '@mui/material'

export const inventoryTabsSx: SxProps<Theme> = {
  minHeight: 48,
  '& .MuiTabs-flexContainer': { gap: 1, py: 0.5 },
  '& .MuiTabs-indicator': { display: 'none' },
  '& .MuiTab-root': {
    minHeight: 40,
    minWidth: 'auto',
    px: 2,
    border: '1px solid #d2e2ec',
    borderRadius: '9px',
    backgroundColor: '#f7fafc',
    color: '#315d77',
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'none',
    transition: 'background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease',
    '&:hover': {
      backgroundColor: '#e8f3f9',
      borderColor: '#8dbbd3',
      boxShadow: '0 3px 8px rgba(45, 116, 156, 0.14)',
      transform: 'translateY(-1px)',
    },
    '&.Mui-focusVisible': { outline: '2px solid #2d749c', outlineOffset: 2 },
    '&.Mui-selected': {
      backgroundColor: '#dceef7',
      borderColor: '#2d749c',
      color: '#195a7f',
      boxShadow: 'inset 0 -2px 0 #2d749c',
    },
    '&.Mui-selected:hover': { backgroundColor: '#d0e7f3' },
  },
}
